<template>
  <div class="get_code">
    <el-dialog title="获取URL" :visible.sync="dialogVisible">
      <el-input
        type="textarea"
        ref="textarea"
        :rows="8"
        placeholder="请输入内容"
        v-model="url"
        readonly
      ></el-input>
      <div class="btn">
        <el-button type="primary" @click="copy">复制</el-button>
      </div>

      <el-input
        type="textarea"
        ref="Apptextarea"
        :rows="8"
        placeholder="请输入内容"
        v-model="AppLeturl"
        readonly
        v-if="tempSystem === '3' || tempSystem === '4'"
      ></el-input>
      <div class="btn">
        <el-button
          type="primary"
          @click="copyAppLet"
          v-if="tempSystem === '3' || tempSystem === '4'"
          >复制小程序启动参数</el-button
        >
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      default: "",
    },
    tempSystem: {
      type: String,
      default: "1",
    },
  },
  data() {
    return {
      dialogVisible: false,
      AppLeturl: "",
      overseasArr: ["tracker_token", "source_platform"],
      oneAppArr: ["nt_appid", "nt_platform", "nt_channel", "nt_os"],
      deArr: ["nt_appid", "nt_platform", "nt_channel", "nt_os", "nt2_os", "nt2_appid"],
    };
  },
  methods: {
    copy() {
      if (!this.url) return;
      // 提取双端监测与非双端的值，通过every方法判断两个数组的值
      let oneAppArr = [];
      let deArr = [];
      let overseasArr = [];
      this.overseasArr.forEach((item) => {
        overseasArr.push(this.getQueryString(item));
      });
      this.oneAppArr.forEach((item) => {
        oneAppArr.push(this.getQueryString(item));
      });
      this.oneAppArr.forEach((item) => {
        oneAppArr.push(this.getQueryString(item));
      });
      this.deArr.forEach((item) => {
        deArr.push(this.getQueryString(item));
      });
      if (
        deArr.every((item) => item) ||
        oneAppArr.every((item) => item) ||
        overseasArr.every((item) => item)
      ) {
        this.$refs.textarea.select();
        document.execCommand("copy");
        this.$message({
          message: "复制成功",
          type: "success",
        });
      } else {
        this.$message({
          type: "error",
          message: "监测链接错误，请勿复制使用，联系中台同学处理",
        });
      }
    },
    copyAppLet() {
      if (!this.AppLeturl) return;
      // 提取双端监测与非双端的值，通过every方法判断两个数组的值
      let oneAppArr = [];
      let deArr = [];
      this.oneAppArr.forEach((item) => {
        oneAppArr.push(this.getQueryString(item));
      });
      this.deArr.forEach((item) => {
        deArr.push(this.getQueryString(item));
      });
      if (deArr.every((item) => item) || oneAppArr.every((item) => item)) {
        this.$refs.Apptextarea.select();
        document.execCommand("copy");
        this.$message({
          message: "复制成功",
          type: "success",
        });
      } else {
        this.$message({
          type: "error",
          message: "监测链接错误，请勿复制使用，联系中台同学处理",
        });
      }
    },
    getQueryString(name) {
      let url = this.url.slice(this.url.indexOf("?"));
      let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      let r = url.substr(1).match(reg);
      console.log(r);
      if (r != null) {
        return unescape(r[2]);
      }
      return null;
    },
  },
  watch: {
    url(newVal) {
      let index = newVal.indexOf("nt_appid=");
      if (index !== -1) {
        this.AppLeturl = newVal.slice(index) + "&requestid=__REQUEST_ID__";
      }
    },
  },
};
</script>

<style lang="less" scoped>
.get_code {
  // padding: 20px;
  background: white;

  .btn {
    margin: 20px 0;
  }
}
</style>
